
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/descargables",
      function () {
        return require("private-next-pages/business/descargables/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/descargables"])
      });
    }
  